import React from 'react';
import { useAtom } from 'jotai';
import MyTable from '../../../components/MyTable';
import MyButton from '../../../components/MyButton';
import { CANCELLATION_REASONS_HEADERS } from '../../../constants/tables';
import styles from '../css/index.module.scss';
import convertHeadersThatAreSortable from '../../../helpers/convertHeadersThatAreSortable';
import {
  cancellationReasonsFiltersAtom,
  cancellationReasonsInfoAtom,
} from '../../../atoms/cancellationReasonsAtoms';
import CancellationReasonsServices from '../../../services/CancellationReasonsServices';

function TableRow({ item, header, onEdit, onDelete }) {
  switch (header.key) {
    case 'id':
      return (
        <div className={styles.tableCell}>
          <p className={styles.tableText}>{item.id}</p>
        </div>
      );
    case 'name':
      return (
        <div className={styles.tableCell}>
          <p className={styles.tableText}>{item.name}</p>
        </div>
      );
    case 'actions':
      return (
        <div className={styles.tableCell}>
          <div className={styles.actionsCell}>
            <MyButton text="Изменить" secondary onClick={(ev) => { ev.stopPropagation(); onEdit(item); }} />
            <MyButton text="Удалить" secondary onClick={(ev) => { ev.stopPropagation(); onDelete(item); }} />
          </div>
        </div>
      );
    default:
      return null;
  }
}

function CancellationReasonsTable({ onEdit, onDelete }) {
  const [info] = useAtom(cancellationReasonsInfoAtom);
  const [filters] = useAtom(cancellationReasonsFiltersAtom);

  const reasons = info.cancellation_reasons || [];
  const sortFields = info.sort_fields || [];
  const headers = convertHeadersThatAreSortable(
    CANCELLATION_REASONS_HEADERS,
    sortFields,
  );
  const totalRecords = info.pages?.total_records ?? reasons.length;
  const totalPages = Math.max(
    1,
    Math.ceil(totalRecords / CancellationReasonsServices.ITEMS_PER_PAGE),
  );

  if (!reasons.length) {
    return <p className={styles.emptyText}>Причин отмены пока нет. Добавьте первую.</p>;
  }

  return (
    <MyTable
      data={reasons}
      headers={headers}
      filtersAtom={cancellationReasonsFiltersAtom}
      renderComponent={(val) => (
        <TableRow {...val} onEdit={onEdit} onDelete={onDelete} />
      )}
      totalPages={totalPages}
      heightToMinus={146}
    />
  );
}

export default CancellationReasonsTable;
